// src/stores/ui.js
import { defineStore } from "pinia";

export const useUIStore = defineStore("ui", {
  state: () => ({
    drawer: true, // visible by default on desktop
    rail: false, // collapsed‐rail mode off by default
    aboutOpen: false, // About shown as a popup, not a routed page
  }),
  actions: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    toggleRail() {
      this.rail = !this.rail;
    },
    openAbout() {
      this.aboutOpen = true;
    },
    closeAbout() {
      this.aboutOpen = false;
    },
  },
});
